import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './price-type.html';
import{ MySiteRestService } from '@nuskin/my-site-api';
import { MySiteApp, OverwritePaperRadioButtonStyles } from '../../my-site-app';
import { nuskin } from '@nuskin/ns-util'

/**
 * @customElement
 * @polymer
 */
export class PriceType extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);
        
        this.descriptionOptions = {
            retail: this.content.priceTypeFormRetailInfo,
            wholesale: this.content.priceTypeFormWholeSaleInfo
        }
        this.description = this.descriptionOptions.wholesale

        // pass save method to form wrapper
        this.parentNode.saveForm = this.save();
    }

    static get properties() {
        return {
            wholesale: {
                type: Boolean,
                value: false,
                observer: '_handlePriceType'
            }
        }
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'price-type';
    }

    connectedCallback() {
        super.connectedCallback();

        this.overwritePaperRadioButtonStyles();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    ready() {
        super.ready();
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
    }

    _subscribeToMySiteDataChanges() {
        if(this.mySite.currentForm !== PriceType.is) return;
        this.set('wholesale', !!this.mySite.mySiteData.storefront[this.mySite.subdomain][this.mySite.currentMarket].lang[this.mySite.currentLanguage].wholesale);
    }

    overwritePaperRadioButtonStyles() {
        OverwritePaperRadioButtonStyles(this.$.wholesale);
        OverwritePaperRadioButtonStyles(this.$.retail);
    }

    _handlePriceType(newVal, oldVal) {
        this.setDescription();
        this.$.wholesale.checked = newVal;
        this.$.retail.checked = !newVal;
    
        if(oldVal !== undefined) {
            this.parentElement.formTouched();
            this.parentElement.setFormValidity(true);
        }
    }

    _handleRetailClick() {
        this.wholesale = false;
        this.$.wholesale.checked = false;
        this.$.retail.checked = true;
        this.parentNode.updateAndNotify(this.wholesale, true, true, 'wholesale');
    }

    _handleWholesaleClick() {
        this.wholesale = true;
        this.$.wholesale.checked = true;
        this.$.retail.checked = false;
        this.parentNode.updateAndNotify(this.wholesale, true, true, 'wholesale');
    }

    setDescription() {
        this.description = this.wholesale
            ? this.descriptionOptions.wholesale
            : this.descriptionOptions.retail;
    }

    save() {
        let that = this;
        return function() {

            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: PriceType.is,
                        changed: {
                            wholesale: that.wholesale
                        }
                    }
                });
            } catch(err) {console.log(err)}

            return MySiteRestService.savePriceType(that.wholesale, that.mySite.currentMarket, that.mySite.currentLanguage, that.mySite.subdomain);
        }
    }

}

window.customElements.define(PriceType.is, PriceType);
